import axios from 'axios';

const apiWhitelist = [];
const pendingRequests = new Map();

function getRequestKey(config) {
  const { method, url, acRequestType } = config;
  return [method, url, acRequestType || 'default'].join('&');
}

function addPendingRequest(config) {
  const requestKey = getRequestKey(config);
  config.cancelToken =
    config.cancelToken ||
    new axios.CancelToken(cancel => {
      if (
        !pendingRequests.has(requestKey) &&
        !apiWhitelist.some(item => requestKey.includes(item))
      ) {
        pendingRequests.set(requestKey, cancel);
      }
    });
}

function removePendingRequest(config) {
  const requestKey = getRequestKey(config);
  if (
    pendingRequests.has(requestKey) &&
    !apiWhitelist.some(item => requestKey.includes(item))
  ) {
    const cancel = pendingRequests.get(requestKey);
    cancel('CancelToken');
    pendingRequests.delete(requestKey);
  }
}

export { addPendingRequest, removePendingRequest };



// WEBPACK FOOTER //
// ./src/common/js/http_stop.js